module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAABnGz2mAAAAAXNSR0IArs4c6QAAATtJREFUSA1j/D7D4j/DIARMg9BNYCeNOozUmBkNsWETYox/zswZlMUF438gIDWYkdWDtK9YcZLh9ZvPDP///WfQ1JJicHPVQVZCFptih02btpfB1k6N4d/f/wx8fJwMr159YXj8+A1DSIgpWQ6CaWKBMcihv3//zcDHz8nw5fNPhmvXnzJwcrIxaGhIMrx4+ZEc41D0UFRcvHr1iUFCgo/h48fvDI8ev2d49vwDw/dvvxl4edlRLCGHQ5HDZGWFGO7ff8sAotVUxBnUVCUYRMX4GN6//06OW1D0UBSVTEyMYEddv/6Mwd5eg4GJmYlh966LDI4OGiiWkMOhOPGDLL177xXDoUO3GFhZmBjc3HQYxIChRilg7DuyiKLiglIH4NLPKNPhPCgdRlHix+VbaoiPOozUUBwNsWETYgDU61zTWBfG+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/India.png
// module id = 474
// module chunks = 7